import styles from "./PageContainer.module.scss";

import { Container, Props as ContainerProps } from "../container/Container";

export const PageContainer = (props: Omit<ContainerProps, "defaultStyle">) => {
    return <Container {...props} defaultStyle={styles.container} />;
};
